import { ArticleCardProps } from '~/components/Slices/ArticleCard'

import { isRTFilled } from '~/utils/check-empty-string'

import serializeCard from './serialize-card'

export default function serializeCardArticle(slice, locale): ArticleCardProps {
  return slice
    ? {
        ...serializeCard(slice, locale),
        // If there is a suptitle we force it then get automatic category then null
        suptitle: isRTFilled(slice?.data?.card_suptitle)
          ? slice?.data?.card_suptitle
          : slice?.data?.category?.data?.name ?? null,
      }
    : null
}
